import { useLayoutEffect } from "react";

export default function useLockBodyScroll(isLocked = true) {
  useLayoutEffect(() => {
    if (!isLocked) return;

    // 1 — remember everything we overwrite
    const { scrollY } = window;
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;
    const originalBodyPosition = document.body.style.position;
    const originalBodyTop = document.body.style.top;
    const originalBodyWidth = document.body.style.width;

    // 2 — prevent scrolling
    document.documentElement.style.overflow = "hidden"; // root
    document.body.style.overflow = "hidden"; // body
    // optional: freeze current scroll position (avoids iOS / momentum scroll)
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      // 3 — restore everything
      document.documentElement.style.overflow = originalHtmlOverflow;
      document.body.style.overflow = originalBodyOverflow;
      document.body.style.position = originalBodyPosition;
      document.body.style.top = originalBodyTop;
      document.body.style.width = originalBodyWidth;
      window.scrollTo(0, scrollY); // jump back to where we were
    };
  }, [isLocked]);
}
